var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { ticketsService } from 'src/Utils/ticketsService';
var parsePositiveNumber = function (value) {
    if (!value)
        return undefined;
    var parsedValue = Number(value);
    if (!Number.isInteger(parsedValue) || parsedValue <= 0) {
        return undefined;
    }
    return parsedValue;
};
var isCompletedTicket = function (ticket) { return ticket.status === 'Completado'; };
export var usePrefilledTicketId = function (_a) {
    var ticketIdParam = _a.ticketIdParam, ticketNumberParam = _a.ticketNumberParam;
    var parsedTicketId = parsePositiveNumber(ticketIdParam);
    var parsedTicketNumber = parsePositiveNumber(ticketNumberParam);
    var shouldResolveFromTicketNumber = parsedTicketId === undefined && parsedTicketNumber !== undefined;
    var _b = useQuery(['ticket-reminder-prefill-by-number', parsedTicketNumber], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (parsedTicketNumber === undefined) {
                        return [2 /*return*/, []];
                    }
                    return [4 /*yield*/, ticketsService.getTickets({
                            ticket_number: String(parsedTicketNumber),
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.tickets || []];
            }
        });
    }); }, { enabled: shouldResolveFromTicketNumber }), _c = _b.data, matchingTickets = _c === void 0 ? [] : _c, isLoading = _b.isLoading;
    var initialTicketId = useMemo(function () {
        if (parsedTicketId !== undefined) {
            return parsedTicketId;
        }
        if (!shouldResolveFromTicketNumber || parsedTicketNumber === undefined) {
            return undefined;
        }
        var matchingTicket = matchingTickets.find(function (ticket) { return ticket.ticket_number === parsedTicketNumber; });
        if (!matchingTicket || isCompletedTicket(matchingTicket)) {
            return undefined;
        }
        return matchingTicket.id;
    }, [
        parsedTicketId,
        parsedTicketNumber,
        shouldResolveFromTicketNumber,
        matchingTickets,
    ]);
    var completedFilteredTicketNumber = useMemo(function () {
        if (!shouldResolveFromTicketNumber || parsedTicketNumber === undefined) {
            return undefined;
        }
        var matchingTicket = matchingTickets.find(function (ticket) { return ticket.ticket_number === parsedTicketNumber; });
        if (!matchingTicket || !isCompletedTicket(matchingTicket)) {
            return undefined;
        }
        return parsedTicketNumber;
    }, [shouldResolveFromTicketNumber, parsedTicketNumber, matchingTickets]);
    return {
        initialTicketId: initialTicketId,
        isResolving: shouldResolveFromTicketNumber && isLoading,
        completedFilteredTicketNumber: completedFilteredTicketNumber,
    };
};
